import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLinkIcon } from 'lucide-react';
import { InteriorSlide, SlideHeader } from './SlideShell';
import type { SlideProps } from './SlideShell';
const EXAMPLES = [{
  title: 'Augmentin knowledge quiz',
  image: 'https://cdn.magicpatterns.com/uploads/oZe7KK4bVsos3NzGeNGvkX/Screenshot_2026-08-18_at_12.33.53.png'
}, {
  title: 'Seretide perception journey',
  image: 'https://cdn.magicpatterns.com/uploads/5acEeeL35iYXBQ1vBXQFmw/Screenshot_2026-08-18_at_12.41.04.png'
}, {
  title: 'Seretide insight reveal',
  image: 'https://cdn.magicpatterns.com/uploads/aGahdEbEEs9eRzXCS2HycX/Screenshot_2026-08-18_at_12.39.06.png'
}, {
  title: 'Solventum interactive poll',
  image: 'https://cdn.magicpatterns.com/uploads/eUYggXqvYjyAWQDdu9UCFx/Screenshot_2026-08-18_at_13.48.12.png'
}, {
  title: 'Itovebi efficacy quiz',
  image: 'https://cdn.magicpatterns.com/uploads/fEr2RvuzYGA5iwinQ4VzrY/Screenshot_2026-08-18_at_13.49.16.png'
}];
export function Slide16NextSteps({}: SlideProps) {
  return <InteriorSlide surface data-id="element-347" data-mp="1ycfhist3jwan">
      <SlideHeader eyebrow="Examples" data-id="element-348" data-mp="1yc732whbsixc">
        Click to explore interactive campaign examples
      </SlideHeader>

      <div className="flex-1 min-h-0 flex flex-col max-w-7xl mx-auto w-full" data-id="element-349" data-mp="1tgi3wu97x41k">
        <p className="mb-5 max-w-3xl text-[clamp(0.9rem,1.2vw,1.1rem)] leading-relaxed text-[var(--muted)]" data-id="element-350" data-mp="1ogvrgn17rrtt">
          A selection of campaign formats showing how approved content can become
          short, engaging HCP experiences.
        </p>

        <div className="grid flex-1 min-h-0 grid-cols-2 gap-4 lg:grid-cols-5" data-id="element-351" data-mp="2cd02nvmhi47b">
          {EXAMPLES.map((example, index) => <motion.a key={example.title} href={example.image} target="_blank" rel="noopener noreferrer" aria-label={`Open ${example.title}`} initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.25 + index * 0.1,
          duration: 0.5
        }} className={`group relative min-h-0 overflow-hidden rounded-2xl border border-black/5 bg-white shadow-sm transition-all hover:-translate-y-1 hover:shadow-xl focus:outline-none focus-visible:ring-4 focus-visible:ring-[var(--brand)]/30 ${index === 4 ? 'col-span-2 lg:col-span-1' : ''}`} data-id="element-352" data-mp="27d5cxveg3knu" data-mpi={index}>
              <img src={example.image} alt={example.title} className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03]" data-id="element-353" data-mp="jhpd0e93cun8" />
              <div className="absolute inset-x-0 bottom-0 flex items-center justify-between gap-3 bg-white/95 px-4 py-3 backdrop-blur" data-id="element-354" data-mp="1zunuv0si6xj9">
                <span className="text-sm font-bold leading-tight text-[var(--fg)]" data-id="element-355" data-mp="24spg9sdej8xw">
                  {example.title}
                </span>
                <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-[var(--brand)] text-white shadow-sm" data-id="element-356" data-mp="2evkw4glssewg">
                  <ExternalLinkIcon className="h-4 w-4" data-id="element-357" data-mp="2nq93qdeui8of" />
                </span>
              </div>
            </motion.a>)}
        </div>
      </div>
    </InteriorSlide>;
}